import { CitySwitchIcon } from './CitySwitchIcon';

/**
 * author: Jeff Anders
 * id 830F6E98-B337-4E3C-A990-AA44622F4E78
 * name city-switch
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/city-switch.svg
 * tags
 * - Places 
 */
export const CitySwapIcon = CitySwitchIcon;
export default CitySwapIcon